(() => {
  "use strict";

  const searchOption = "options[unavailable_products]";
  const predictiveSearchOption = "resources[options][unavailable_products]";
  const reservationProductPath = "/products/jeu-echecs-origine";
  const searchResultTypes = "product,page";

  function isStorefrontSearchForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;

    const action = form.getAttribute("action") || "";
    return /(?:^|\/)search(?:[/?#]|$)/.test(action) &&
      Boolean(form.querySelector("input[name='q']"));
  }

  function showUnavailableProducts(form) {
    if (!isStorefrontSearchForm(form)) return;

    let option = form.querySelector(`input[name="${searchOption}"]`);
    if (!option) {
      option = document.createElement("input");
      option.type = "hidden";
      option.name = searchOption;
      form.append(option);
    }

    option.value = "show";

    let type = form.querySelector("input[name='type']");
    if (!type) {
      type = document.createElement("input");
      type.type = "hidden";
      type.name = "type";
      form.append(type);
    }
    type.value = searchResultTypes;
  }

  function updateSearchForms(root = document) {
    if (root instanceof HTMLFormElement) showUnavailableProducts(root);

    if (root instanceof Element || root instanceof Document) {
      root.querySelectorAll("form").forEach(showUnavailableProducts);
    }
  }

  function injectReservationStyles() {
    if (document.getElementById("edr-search-reservation-styles")) return;

    const style = document.createElement("style");
    style.id = "edr-search-reservation-styles";
    style.textContent = `
      .ecom-collection__product-item [data-edr-reservation-action] {
        align-items: center !important;
        background: transparent !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-sizing: border-box !important;
        color: #0b0b0b !important;
        display: inline-flex !important;
        font-family: "Overpass Mono", "OverpassMono-Light", monospace !important;
        font-size: 12px !important;
        font-weight: 400 !important;
        justify-content: center !important;
        letter-spacing: 0.08em !important;
        line-height: 1.2 !important;
        min-height: 0 !important;
        padding: 0 !important;
        text-transform: uppercase !important;
      }

      .ecom-collection__product-item [data-edr-reservation-action] .ecom-collection__product-sold-out-text,
      .ecom-collection__product-item [data-edr-reservation-badge] {
        color: #0b0b0b !important;
        font-family: "Overpass Mono", "OverpassMono-Light", monospace !important;
        font-size: 12px !important;
        font-weight: 400 !important;
        letter-spacing: 0.08em !important;
        line-height: 1.2 !important;
        text-transform: uppercase !important;
      }
    `;
    document.head.append(style);
  }

  function findReservationLinks(root) {
    const selector = `a[href*="${reservationProductPath}"]`;
    const links = [];

    if (root instanceof HTMLAnchorElement && root.matches(selector)) links.push(root);
    if (root instanceof Element || root instanceof Document) {
      links.push(...root.querySelectorAll(selector));
    }

    return links;
  }

  function updateReservationLabels(root = document) {
    findReservationLinks(root).forEach((link) => {
      const card = link.closest(".ecom-collection__product-item");
      if (!card) return;

      card.querySelectorAll(".ecom-collection__product-form__actions--soldout").forEach((action) => {
        action.dataset.edrReservationAction = "true";
      });

      card.querySelectorAll(".ecom-collection__product-sold-out-text").forEach((label) => {
        label.textContent = "SUR RÉSERVATION";
      });

      card.querySelectorAll(".ecom-collection__product-badge--sold-out").forEach((badge) => {
        badge.dataset.edrReservationBadge = "true";
        badge.textContent = "SUR RÉSERVATION";
      });
    });
  }

  function patchPredictiveSearchFetch() {
    if (window.__edrUnavailableProductsSearchPatched || typeof window.fetch !== "function") {
      return;
    }

    const originalFetch = window.fetch;
    window.__edrUnavailableProductsSearchPatched = true;

    // The theme's predictive-search module uses a string URL for this endpoint.
    window.fetch = function (input, init) {
      if (typeof input === "string") {
        const url = new URL(input, window.location.origin);
        if (
          /\/search\/suggest(?:\.json)?$/.test(url.pathname) &&
          !url.searchParams.has(predictiveSearchOption)
        ) {
          url.searchParams.set(predictiveSearchOption, "show");
          url.searchParams.set("resources[type]", "product,collection,page,query");
          return originalFetch.call(this, url.toString(), init);
        }
      }

      return originalFetch.call(this, input, init);
    };
  }

  function initialize() {
    updateSearchForms();
    injectReservationStyles();
    updateReservationLabels();
    patchPredictiveSearchFetch();

    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            updateSearchForms(node);
            updateReservationLabels(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("submit", (event) => {
    if (event.target instanceof HTMLFormElement) showUnavailableProducts(event.target);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
